<template>
  <div>
    <v-dialog v-model="show" persistent max-width="70%">
      <v-card>
        <v-app-bar dark text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("enrolments.title_org") }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('enrolments.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="companies"
            :items-per-page="companies.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selected"
            :must-sort="true"
          >
          </v-data-table>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <action-button type="cancel" @click="cancel" small />
          <action-button type="save" @click="submit" small />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EnrolmentOrganisationListPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    except_ids: {
      type: Array
    },
  },

  data() {
    return {
      url: "",
      selected: [],
      companies: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: []
      },
      search_params: {
        any: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("enrolments.o_name"), value: "name" },
          { text: this.$t("enrolments.o_vat"), value: "vat" },
          { text: this.$t("enrolments.o_address_zip"), value: "visiting_zip" },
          { text: this.$t("enrolments.o_address_country"), value: "visiting_country" },
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh && this.show) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.companies = []
          this.list()
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "enrolments/organisations"
  },

  methods: {
    list() {
      this.show_loading = true
      this.search_params.not_in_ids = this.except_ids ? this.except_ids.join(",") : null

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.companies = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    cancel() {
      this.$emit("callback_enrorglistpopup_cancel")
    },

    submit() {
      this.$emit("callback_enrorglistpopup_submit", this.selected)
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
